import { useRef, useState } from "react";
import moment from "jalali-moment";

import { getAdminReportService } from "../../../services/userServices";
import { downloadBlob, downloadErrorMessage } from "../../../utils/downloadFile";

const AdminReports = () => {
  const [report, setReport] = useState("divar_orders");
  const [since, setSince] = useState(() => moment().subtract(30, "days").locale("fa").format("jYYYY-jMM-jDD"));
  const [through, setThrough] = useState(() => moment().locale("fa").format("jYYYY-jMM-jDD"));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const pending = useRef(false);

  const handleDownload = async (event) => {
    event.preventDefault();
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    setError("");
    setSuccess(false);
    try {
      const { data } = await getAdminReportService({ report, since: since.trim(), through: through.trim() });
      downloadBlob(data, `${report}.zip`);
      setSuccess(true);
    } catch (failure) {
      setError(await downloadErrorMessage(failure, "ساخت گزارش ناموفق بود؛ با بازه کوتاه‌تر دوباره تلاش کنید."));
    } finally {
      pending.current = false;
      setBusy(false);
    }
  };

  return (
    <section className="mb-4" aria-labelledby="admin-reports-title">
      <h4 id="admin-reports-title">گزارش‌های سفارش و مالی</h4>
      <p className="text-muted">گزارش‌ها مربوط به کرمان و رفسنجان هستند. بازه بر اساس تاریخ ثبت سفارش، شامل روز ابتدا و انتهاست.
        فایل ZIP شامل CSV دریافت می‌شود؛ متن نظرات در خروجی قرار نمی‌گیرد.</p>
      <form onSubmit={handleDownload}>
        <fieldset disabled={busy}>
          <div className="row">
            <div className="col-md-4 mb-2">
              <label htmlFor="admin-report-type">نوع گزارش</label>
              <select id="admin-report-type" className="form-control" value={report} onChange={(event) => setReport(event.target.value)}>
                <option value="divar_orders">تحلیل سفارش‌های دیوار</option>
                <option value="order_finance">گزارش مالی سفارش‌ها</option>
              </select>
            </div>
            <div className="col-md-4 mb-2">
              <label htmlFor="admin-report-since">از تاریخ (شمسی)</label>
              <input id="admin-report-since" className="form-control" dir="ltr" required value={since}
                placeholder="1405-07-05" onChange={(event) => setSince(event.target.value)} />
            </div>
            <div className="col-md-4 mb-2">
              <label htmlFor="admin-report-through">تا تاریخ (شمسی)</label>
              <input id="admin-report-through" className="form-control" dir="ltr" required value={through}
                placeholder="1405-08-05" onChange={(event) => setThrough(event.target.value)} />
            </div>
          </div>
          <p className="text-muted small">حداکثر بازه ۳۶۶ روز است. برای گزارش‌های حجیم، بازه را کوتاه کنید. تا پایان ساخت فایل منتظر بمانید.</p>
          <button className="btn btn-primary" type="submit">{busy ? "در حال ساخت گزارش..." : "ساخت و دانلود گزارش"}</button>
        </fieldset>
      </form>
      {busy && <p role="status" className="mt-2">گزارش در حال آماده‌سازی است؛ درخواست مجدد لازم نیست.</p>}
      {error && <p role="alert" className="alert alert-danger mt-2">{error}</p>}
      {success && <p role="status" className="alert alert-success mt-2">گزارش آماده شد و دانلود آغاز شد.</p>}
    </section>
  );
};

export default AdminReports;
